import Modal from './Modal';
import Header from './Header';
import Main from './Main';
import { useEffect, useState } from 'react';
import cleanDate from './tools/cleanDate';

export default function App() {
  const [numDays, setNumDays] = useState(() => {
    const storedSettings = JSON.parse(localStorage.getItem('settings'));
    if (storedSettings) {
      return storedSettings.numDays;
    } else {
      return 4;
    }
  });

  const today = cleanDate(new Date());

  const [tasks, setTasks] = useState(() => {
    const storedTasks = JSON.parse(localStorage.getItem('tasks'));
    if (storedTasks) {
      return storedTasks
        .map(task => {
          return { ...task, date: new Date(task.date) };
        })
        .filter(task => today.getTime() <= task.date.getTime());
    } else {
      return [];
    }
  });

  const [selectedTask, setSelectedTask] = useState(null);
  const [modalMode, setModalMode] = useState(null);
  const [deleteMode, setDeleteMode] = useState(false);

  useEffect(() => {
    localStorage.setItem('tasks', JSON.stringify(tasks));
  }, [tasks]);
  useEffect(() => {
    localStorage.setItem('settings', JSON.stringify({ numDays }));
  }, [numDays]);

  const [selectedDay, setSelectedDay] = useState(today);

  const selectedDayTasks = tasks.filter(
    task => task.date.getTime() === selectedDay.getTime()
  );

  const numSelectedDayTasks = selectedDayTasks.length;

  function handleCloseModal() {
    setModalMode(null);
    setSelectedTask(null);
  }

  function handleAddTask(task) {
    setTasks(tasks => [...tasks, task]);
  }

  function handleTaskDoneToggle(id) {
    setTasks(tasks =>
      tasks.map(task => (task.id === id ? { ...task, done: !task.done } : task))
    );
  }

  function handleSelectTask(id) {
    setSelectedTask(...tasks.filter(task => task.id === id));
    setModalMode('edit');
  }

  function handleEditTask(editedTask) {
    setTasks(tasks =>
      tasks.map(task => (task.id === editedTask.id ? editedTask : task))
    );
  }

  function handleDeleteToggle() {
    if (numSelectedDayTasks > 0) {
      setDeleteMode(cur => !cur);
    }
  }

  function handleDeleteTask(ids) {
    if (Array.isArray(ids)) {
      setTasks(tasks => tasks.filter(task => !ids.includes(task.id)));
      setDeleteMode(false);
    } else if (typeof ids === 'number') {
      setTasks(tasks => tasks.filter(task => ids !== task.id));
    }
  }

  return (
    <div className="bg-secondary/40">
      <div
        className={`app font-vazir relative min-h-screen overflow-hidden flex flex-col max-w-lg bg-white mx-auto md:shadow-2xl md:rounded-4xl`}
      >
        <Modal
          setNumDays={setNumDays}
          numDays={numDays}
          modalMode={modalMode}
          onCloseModal={handleCloseModal}
          onAddTask={handleAddTask}
          selectedTask={selectedTask}
          onEditTask={handleEditTask}
          onDeleteTasks={handleDeleteTask}
          today={today}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
        />

        <Header
          today={today}
          setModalMode={setModalMode}
          numTasks={numSelectedDayTasks}
          onDeleteToggle={handleDeleteToggle}
          deleteMode={deleteMode}
          selectedDay={selectedDay}
        />

        <Main
          numDays={numDays}
          tasks={selectedDayTasks}
          numTasks={numSelectedDayTasks}
          onTaskDoneToggle={handleTaskDoneToggle}
          selectedDay={selectedDay}
          onChangeDay={setSelectedDay}
          today={today}
          onSelectTask={handleSelectTask}
          deleteMode={deleteMode}
          onCancelDelete={() => setDeleteMode(false)}
          onDeleteTasks={handleDeleteTask}
        />
      </div>
    </div>
  );
}
